export default __webpack_public_path__ + "static/media/menu.3e3bbfc9.md";